import * as Consts from "../../ts/rlAdmin.consts";
import * as Models from "../../ts/rlAdmin.models";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";

export class RightsDimensionsSettingsConfigController {
    static $inject = ["$q", "adminConfigService", "notifyService"];

    allRightsDimensionsModel: Models.IRightsDimensions[];
    selectedRightsDimensionsModel: Models.IRightsDimensions[];
    dim2Dimensions: Models.IRightsDimensions[];
    dim1Dimensions: Models.IRightsDimensions[];
    dim3Dimensions: Models.IRightsDimensions[];
    dim4Dimensions: Models.IRightsDimensions[];

    selectedTerritoryDimensionValueSourceID: string;
    selectedMediaDimensionValueSourceID: string;
    selectedLanguageDimensionValueSourceID: string;
    selectedChannelDimensionValueSourceID: string;

    constructor(private $q: ng.IQService, private adminConfigService: AdminConfigService, private notifyService: NotifyService) {

    }

    Init() {
        this.notifyService.startProgress();
        var getRightsDimensionsPromise = this.adminConfigService.getRightsDimensions()
            .then((result) => {
                this.allRightsDimensionsModel = [];
                if (result.success) {
                    this.allRightsDimensionsModel = result.data;
                }
            });

        var systemIndicatorID: number = 0;
        var getSelectedRightsDimensionsPromise = this.adminConfigService.getSelectedRightsDimensions(systemIndicatorID)
            .then((result) => {
                this.selectedRightsDimensionsModel = [];
                if (result.success) {
                    this.selectedRightsDimensionsModel = result.data;
                }
            });


        this.$q.all([getRightsDimensionsPromise, getSelectedRightsDimensionsPromise])
            .then(() => {

                this.dim1Dimensions = _.filter(this.allRightsDimensionsModel, d => d.systemIndicatorID == Consts.SystemIndicators.Rightset.media);
                this.dim2Dimensions = _.filter(this.allRightsDimensionsModel, d => d.systemIndicatorID == Consts.SystemIndicators.Rightset.territory);
                this.dim3Dimensions = _.filter(this.allRightsDimensionsModel, d => d.systemIndicatorID == Consts.SystemIndicators.Rightset.language);
                this.dim4Dimensions = _.filter(this.allRightsDimensionsModel, d => d.systemIndicatorID == Consts.SystemIndicators.Rightset.channel);

                if (_.any(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.media)) {
                    this.selectedMediaDimensionValueSourceID = _.find(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.media).charValueSourceID;
                }
                else {
                    this.selectedMediaDimensionValueSourceID = "";
                }

                if (_.any(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.territory)) {
                    this.selectedTerritoryDimensionValueSourceID = _.find(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.territory).charValueSourceID;
                }
                else {
                    this.selectedTerritoryDimensionValueSourceID = "";
                }

                if (_.any(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.language)) {
                    this.selectedLanguageDimensionValueSourceID = _.find(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.language).charValueSourceID;
                }
                else {
                    this.selectedLanguageDimensionValueSourceID = "";
                }

                if (_.any(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.channel)) {
                    this.selectedChannelDimensionValueSourceID = _.find(this.selectedRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.channel).charValueSourceID;
                }
                else {
                    this.selectedChannelDimensionValueSourceID = "";
                }
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    Save() {
        var updateRightsDimensions: Models.IRightsDimensions[] = [];

        if (this.selectedTerritoryDimensionValueSourceID == undefined || this.selectedMediaDimensionValueSourceID == undefined
            || this.selectedLanguageDimensionValueSourceID == undefined || this.selectedChannelDimensionValueSourceID == undefined) {
            alert("Please Select one value source for each dimension");
        }
        else {
            var selectedTerritoryDimension = _.find(this.allRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.territory && r.charValueSourceID == this.selectedTerritoryDimensionValueSourceID);
            updateRightsDimensions.push(selectedTerritoryDimension);
            var selectedMediaDimension = _.find(this.allRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.media && r.charValueSourceID == this.selectedMediaDimensionValueSourceID);
            updateRightsDimensions.push(selectedMediaDimension);
            var selectedLanguageDimension = _.find(this.allRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.language && r.charValueSourceID == this.selectedLanguageDimensionValueSourceID);
            updateRightsDimensions.push(selectedLanguageDimension);

            if (this.selectedChannelDimensionValueSourceID != undefined && !_.isEmpty(this.selectedChannelDimensionValueSourceID)) {
                var selectedChannelDimension = _.find(this.allRightsDimensionsModel, r => r.systemIndicatorID == Consts.SystemIndicators.Rightset.channel && r.charValueSourceID == this.selectedChannelDimensionValueSourceID);
                updateRightsDimensions.push(selectedChannelDimension);
            }

            this.notifyService.startProgress();
            this.adminConfigService.updateSelectedRightsDimensions(updateRightsDimensions)
                .then((result) => {
                    if (result.success && result.data) {
                        this.notifyService.notifySuccess("Success");
                    }
                    else {
                        this.notifyService.notifyError("Failed");
                    }
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }
}